module.exports = __webpack_public_path__ + "img/sint_paulusschool.60283040.png";